var _defs, _g, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 580.5 247.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#000;stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo.68b17e733347aa0a417e3860f62bb313") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.5,120.2c0,34.5-20.3,64.6-60.3,64.6-38.2,0-58.7-28.4-58.7-64,0-36,22-64,60.3-64C102.8,56.6,125.5,82.4,125.5,120.2Zm-94.7-.1c0,25.2,11.7,45.4,35.4,45.4,25.6,0,35.2-21.3,35.2-45,0-24.7-10.8-44.6-35.4-44.6S30.8,95.1,30.8,120.1Z",
    transform: "translate(-6.5 -56.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.5,173.6v45H143.3V112.8c0-7.5,0-15-.2-22.4h21.7a107.36,107.36,0,0,1,.7,12.5c4.3-7.6,13-14.7,28-14.7,21,0,36.9,17.6,36.9,46.1,0,32.8-17.9,50.8-40.3,50.8C176.4,185.1,169.3,179.7,165.5,173.6Zm42.1-38.4c0-17.9-7.6-28.7-21-28.7-16.1,0-22.1,10.3-22.1,30.2,0,19.1,5.3,30.4,20.9,30.4C200.2,167,207.6,155.4,207.6,135.2Z",
    transform: "translate(-6.5 -56.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.5,141.3c.1,14,7.1,26,20.8,26,12,0,15.6-5.4,18.2-11.4h22.4c-3.4,11.5-13.4,29.2-41.3,29.2-30,0-42.8-23.1-42.8-47.2,0-28.5,14.5-49.6,43.7-49.6,31.1,0,41.6,23.3,41.6,45.3a64.41,64.41,0,0,1-.3,7.8H262.5v-.1ZM302.7,127c-.2-12.3-5.6-22.4-19.2-22.4S264.2,114,263,127Z",
    transform: "translate(-6.5 -56.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.4,113.7c0-7.9,0-16.4-.2-23.3h21.7c.5,2.5.8,10,.9,12.9,3.3-6.5,10.8-15.1,27.6-15.1,18.2,0,30.7,11.9,30.7,35.6v59.1H398.7V126.4c0-11.6-4.1-19.8-16.4-19.8-13.1,0-19.6,8.5-19.6,25.6v50.7H340.3V113.7Z",
    transform: "translate(-6.5 -56.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.2,151.2l-11,31.7h-23l43-124.5h29.2l44.8,124.5H524.6l-11.5-31.7Zm41.6-19.3c-9.9-28.5-15.8-45.5-18.7-56.1h-.2c-3.1,11.7-9.6,31.7-17.6,56.1Z",
    transform: "translate(-6.5 -56.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587,58.4V182.9H563.7V58.4Z",
    transform: "translate(-6.5 -56.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7,303.1H231a29.33,29.33,0,0,1-.8-6.2c-2.8,4.1-8,7-16.5,7-16,0-24.8-12.1-24.8-27.9,0-16.6,9.5-29.1,26.7-29.1,13.8,0,22,7.7,23.5,17.3H228.7c-1.4-4.6-4.8-9-13.2-9-11.9,0-15.7,9.8-15.7,20.4,0,10.2,4.2,20,15.7,20,11,0,13.3-7.5,13.3-13.9v-.5H215.5v-8.6H239v30.5Z",
    transform: "translate(-6.5 -56.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.3,303.1V244.6h9.9v58.5Z",
    transform: "translate(-6.5 -56.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.8,282.4c0,12.2-7.2,21.6-20.1,21.6-12.4,0-19.8-9.1-19.8-21.4,0-12.5,7.4-21.6,20.3-21.6C297.1,261,304.8,269.5,304.8,282.4Zm-29.7.1c0,8.3,3.8,13.6,9.9,13.6s9.7-5.2,9.7-13.6c0-8.8-3.5-13.7-9.9-13.7C278.8,268.9,275.1,273.6,275.1,282.5Z",
    transform: "translate(-6.5 -56.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.6,244.6h9.9v22.3c1.8-2.9,5.3-5.8,12.2-5.8,10.9,0,16.8,9,16.8,20.8,0,12-6.1,22.3-17.9,22.3-6.3,0-9.2-2-11.2-5.4a26.49,26.49,0,0,1-.4,4.4h-9.5c.1-4.5.1-9.1.1-13.6Zm28.8,37.3c0-7.5-3.1-12.9-9.5-12.9-7.3,0-9.8,4.8-9.8,13.6,0,7.5,2.3,13.3,9.6,13.3C337,296,340.4,290.5,340.4,281.9Z",
    transform: "translate(-6.5 -56.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,293a70.29,70.29,0,0,0,.6,10.1h-9.5a16.86,16.86,0,0,1-.6-4.5c-1.5,2.5-4.4,5.4-11.9,5.4-9.8,0-14-6.4-14-12.8,0-9.3,7.4-13.6,19.5-13.6h6.3v-2.8c0-3.2-1.1-6.6-7.2-6.6-5.5,0-6.6,2.5-7.2,5.6h-9.5c.6-6.8,4.8-12.9,17-12.8,10.7.1,16.5,4.3,16.5,13.9V293Zm-9.7-9.1h-5.3c-7.3,0-10.5,2.2-10.5,6.7,0,3.4,2.2,6.1,6.6,6.1,8.1,0,9.2-5.6,9.2-11.7v-1.1Z",
    transform: "translate(-6.5 -56.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.7,303.1V244.6h9.9v58.5Z",
    transform: "translate(-6.5 -56.8)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.57,
    y: 216.64,
    width: 100,
    height: 7,
    rx: 3.2,
    ry: 3.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 434.2,
    y: 216.64,
    width: 100,
    height: 7,
    rx: 3.2,
    ry: 3.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c1871b2a427f1cf40cfb68def7a5c7cd.svg";
export { ForwardRef as ReactComponent };